export type TopicStatus = 'past' | 'featured' | 'scheduled' | 'draft';

export type Topic = {
  ep: string;
  date: string;
  title: string;
  status: TopicStatus;
  blurb: string;
  questions: string[];
};

export const TOPICS_ROADMAP: readonly Topic[] = [
  {
    ep: '01',
    date: 'May 29',
    title: "Let's Get Real: Agentic Software Engineering, is it working?",
    status: 'featured',
    blurb:
      'The big one. Five engineers and two agents argue about whether autonomous coding is delivering, leaking, or just rebranded autocomplete.',
    questions: [
      'When you say "agentic software engineering" in your own org, what does that actually mean in practice today — and what\'s still aspirational?',
      "What's the most ambitious task you've successfully handed off to an AI agent end-to-end — and what's the one you tried that completely fell apart?",
      'Where is the line today between "AI-assisted" coding and truly "agentic" — and is that line moving faster than teams can adapt?',
      "Skeptic's seat: what are vendors overselling right now about agentic engineering, and what should buyers push back on?",
      'How are you measuring whether an agent is actually working — beyond "it shipped a PR"? What metrics matter?',
      'What does the human review loop look like in your team today, and how has it changed in the last 6 months?',
      'What kinds of work are agents genuinely good at right now — and what kinds should teams stop trying to force?',
      'When an agent makes a bad call in production, who debugs it — and how do you even reconstruct what it was "thinking"?',
      "What's the biggest organizational change required to make agentic engineering work — tooling, process, or people?",
      "Twelve months from now, what's a capability you'd bet is real — and one the industry will quietly walk back?",
    ],
  },
  {
    ep: '02',
    date: 'Jun 19',
    title: 'Will AI Replace Software Engineers?',
    status: 'scheduled',
    blurb: '"Your next coworker doesn\'t need coffee — should you be worried?"',
    questions: [
      "Let's start blunt: in 5 years, will there be more software engineers employed globally, or fewer? Defend your number.",
      "Which parts of the engineer's job are already gone — not \"will be,\" but already gone in your org today?",
      'If a junior engineer asked you tonight whether they should still pursue this career, what do you actually tell them?',
      'Skeptic\'s seat: every previous "engineers will be replaced" wave (offshoring, no-code, low-code) underdelivered. Why is this one different — or is it?',
      'What does "10x engineer" mean in an AI-augmented world — and is that 10x coming from the human or the tooling?',
      'Which engineering skills are appreciating in value right now, and which are quietly depreciating?',
      "Are we replacing engineers, or are we replacing the work that used to be done by 5 engineers with 1 engineer plus agents? What's the honest headcount math?",
      "What's a task you'd never let AI own end-to-end today, no matter how good it gets in the next 24 months?",
      'If hiring shifts from "can you code?" to "can you direct AI to code?", what do interviews and onboarding look like?',
      'Final word: replace, augment, or transform — pick one and tell us what it means for the engineer in 2030.',
    ],
  },
  {
    ep: '03',
    date: 'Jul 17',
    title: 'AI & Code Quality: Savior or Saboteur?',
    status: 'scheduled',
    blurb: '"It writes code fast. But is fast code good code?"',
    questions: [
      'Define "code quality" in 2026 — has the bar changed now that machines are writing most of it?',
      'Is AI-generated code in your codebase measurably better, worse, or just different from human-written code? What does the data say?',
      "What's the most insidious bug pattern you've seen come out of AI-generated code — the kind that ships and bites you 3 months later?",
      "Skeptic's seat: are we trading short-term velocity for long-term technical debt that we can't even read anymore?",
      'How do you review a 2,000-line PR that an agent wrote in 4 minutes — honestly, are humans actually reading it?',
      'Has AI changed your testing strategy? Are you testing AI-written code differently than human-written code — and should you be?',
      'What about maintainability — in 3 years, who maintains code that no human ever fully understood when it was written?',
      'Where has AI genuinely raised your code quality — not just speed? Concrete example.',
      'Static analysis, linters, AI reviewers — is the new quality stack actually catching issues, or just generating more noise?',
      'If you had to set one non-negotiable rule for AI-generated code in production tomorrow, what would it be?',
    ],
  },
];
